<template>
  <v-container class="pa-0">
      <v-row>
          <v-col class="pa-3" cols="12" sm="6" md="12">
              <v-card outlined class="pa-4" width="100%" height="230px">
                  <h2>Previsto x Faturado</h2>
                  <p class="mb-3" style="font-size:10px">{{filter? filter.prest_nome : 'GERAL'}} | MÊS CORRENTE</p>
                  <v-card-text class="">
                      <p style="font-family:Cairo;font-size:16px" class="text-center mb-0"><b>{{cardMes.total_previsto | formatPrice}}</b></p>
                      <p style="font-size:10px" class="text-center">TOTAL PREVISTO</p>

                      <p style="font-family:Cairo;font-size:16px" class="text-center mb-0"><b>{{cardMes.total_transmitido | formatPrice}}</b></p>
                      <p style="font-size:10px" class="text-center">TOTAL TRANSMITIDO</p>

                      <div style="font-family:Cairo;font-size:16px; color:orange" class="text-center">{{cardMes.perc_planejado}}% do planejado</div>
                  </v-card-text>
              </v-card>
          </v-col>
          <v-col class="pa-3" cols="12" sm="6" md="12">
              <v-card outlined class="pa-4" width="100%" height="100%">
                  <h2>Evolução do Faturamento anual</h2>
                  <p style="font-size:10px">
                      {{filter? filter.prest_nome : 'GERAL'}}  | {{month}}/ <span style="font-size:11px">{{cardAno.ano}}</span>
                  </p>
                  <v-row>
                      <v-col style="font-family:Cairo; font-size:10px;" id='transmitido_texto' class="px-2 py-1" cols="6">{{cardAno.total_transmitido | formatPrice}} Transmitido</v-col>
                      <v-col class="text-right px-2 py-0" id='transmitido_perc' cols="6">{{dpProgress}}%</v-col>
                      <v-col class="px-1 py-0" cols="12">
                        <div class="bar" ref='bar'> 
                            <div id='progress' ref='progress' role="progressbar"
                                aria-valuenow="20" aria-valuemin="0" :aria-valuemax="dpProgress>percPrevisto? dpProgress : percPrevisto">
                                {{dpProgress}}
                            </div> 
                        </div>
                      </v-col>       
                      <v-col style="font-family:Cairo;font-size:10px" class="px-2 py-1" cols="6">{{cardAno.total_previsto | formatPrice}} Previsto</v-col>
                  </v-row>
              </v-card>
          </v-col>
      </v-row>
  </v-container>
</template>

<script>
import moment from "moment"
moment.locale('pt-BR')
export default {
    data() {
        return {
            dpProgress: 0,
            percPrevisto: 100,
            interval: '',
            month: null
        }
    },
    filters: {
        formatPrice(value) {
            let val = (value/1).toFixed(2).replace('.', ',')
            return 'R$ ' + val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
        }
    },
    watch: {
        cardAno(val) {
            if (val.mes == '01') {
                this.month = `JAN`
            } else {
                let date = moment(new Date(`${val.ano}-${val.mes}-01`)).format('ll').substring(5,8)
                this.month = (`jan - ${date}`).toUpperCase()
            }
        }
    },
    mounted() {
        let size = this.dpProgress > 100? 100: this.dpProgress
        document.getElementById('progress').className = this.dpProgress < 1 ? 
        'progress-bar bg-danger' :
        'progress-bar orange'
         document.getElementById('transmitido_texto').style.color = this.dpProgress < 1 ? 
        '#ff9800' : '#ff9800'
        document.getElementById('transmitido_perc').style.color = this.dpProgress < 1 ? 
        '#ff9800' : '#ff9800'
        this.interval = setTimeout(() => {
            this.dpProgress=this.cardAno.perc_planejado
            if(this.cardAno && this.cardAno.perc_planejado){
                size = this.dpProgress <= 100 ? 100 : 10000/this.dpProgress
                this.percPrevisto = size < 2 ? 2: size
            }
            let sizeProgress = this.dpProgress > 7000? 7000 : this.dpProgress
            this.$refs['bar'].style.width=this.percPrevisto+'%'
            this.$refs['progress'].style.width= sizeProgress + '%'
        }, 10000);
    },
    updated() {
        document.getElementById('progress').className = this.dpProgress < 1 ? 
        'progress-bar bg-danger' :
        'progress-bar orange'
         document.getElementById('transmitido_texto').style.color = this.dpProgress < 10 ? 
        '#ff9800' : '#ff9800'
        document.getElementById('transmitido_perc').style.color = this.dpProgress < 10 ? 
        '#ff9800' : '#ff9800'
        //clearInterval( this.interval)
        //if(!this.dpProgress){
            this.interval = setTimeout(() => {
                let size
                this.dpProgress=this.cardAno.perc_planejado
                if(this.cardAno && this.cardAno.perc_planejado){
                    size = this.dpProgress <= 100 ? 100 : 10000/this.dpProgress
                    this.percPrevisto = size < 2 ? 2 : size
                }
                let sizeProgress = this.dpProgress > 7000? 7000 : this.dpProgress
                this.$refs['bar'].style.width=this.percPrevisto+'%'
                this.$refs['progress'].style.width= sizeProgress + '%'
            }, 100);
        // } else {
        //     clearInterval( this.interval)
        // }
    },
    props: {
        cardAno: Object,
        cardMes: Object,
        filter: Object
    }
}
</script>

<style scoped>
h2 {
  color: #430F4A;
  font-size: 16px;
  letter-spacing: 0.39px;
  line-height: 22px;
  font-weight: 500;
}
.bar {
  height: 9px;
  width: 100%;
  border-radius: 12px;
  background-color:#909090;
  border: 1px solid#909090;
}
div#progress {
    /* margin-top: 1px; */
    height: 6px;
    font-size: 0;
    border-radius: 12px;
}
</style>